<template>
  <div>
    <div
      class="fantan-bet-lot-cell"
      :class="{ 'fantan-bet-lot-cell-active': win, [size]: size }"
    >
      <div
        class="fantan-bet-lot-title"
        :class="{ [size]: size }"
        justify="center"
        align="middle"
      >
        <!-- {{test}} -->
        <!-- <span v-html="$t(`${game}.${type}`)"></span> -->
        <!-- <span> {{ $t("fantan.fan") }} </span> -->
        <span v-if="this.type == 'odd' || this.type == 'even'">{{
          $t(`${this.game}.${this.type}`)
        }}</span>
        <span v-else>&nbsp;</span>
        <!-- &nbsp; -->
      </div>
      <div
        class="fantan-bet-lot-bet-no"
        :class="{ [size]: size }"
        justify="center"
      >
        <span v-if="this.type == 'odd' || this.type == 'even'">{{ odd }}</span>
        <span v-else>&nbsp;</span>
        <!-- &nbsp; -->
      </div>
    </div>
    <div v-if="stakeRecordSum" class="fantan-bet-lot-stake-total">
      {{ stakeRecord }}
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style>
</style>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "win", "game", "size", "stakeRecordSum", "triToggle"],
  components: {
    Row,
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    gametitle() {
      return this.$t(`${this.game}.${this.type}`).charAt(0); //1
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.open-result .fantan-bet-lot-cell-active {
  background: linear-gradient(to right, #1a6dbc, #52b2ff);
  color: #fff;
}

.open-result .fantan-bet-lot-cell-active .fantan-bet-lot-title,
.open-result .fantan-bet-lot-cell-active .fantan-bet-lot-bet-no {
  color: #fff;
  opacity: 1;
}

.fantan-bet-lot-cell {
  width: 100%;
  text-align: center;
  position: relative;
}

.fantan-bet-lot-cell.small {
  padding-top: 10px;
  padding-bottom: 6px;
}

.fantan-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.fantan-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.fantan-bet-lot-title {
  font-family: "Oswald";
  text-align: center;
  font-weight: bold;
  // text-transform: uppercase;
  font-size: 12px;
  color: #ffffff;
  text-shadow: 0px 1px 0px #00000029;
  // padding: 0 9px;
}

.fantan-bet-lot-title .g-title {
  font-size: 23px;
}

.tri-left .fantan-bet-lot-title,
.tri-right .fantan-bet-lot-title {
  padding: 0;
}

.middle .fantan-bet-lot-title {
  font-family: "Oswald";
  text-align: center;
  font-weight: bold;
  // text-transform: uppercase;
  font-size: 12px;
  color: #ffffff;
  text-shadow: 0px 1px 0px #00000029;
  padding: 0;
}

.fantan-bet-lot-title.small {
  height: unset;
  margin-top: 5px;
}

.fantan-bet-lot-bet-no {
  // @extend .tai-xiu-game-bet-no;
  // margin-top: 0px;
  font-family: "Oswald";
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  // padding: 13px 0 7px;
  text-shadow: 0px 1px 0px #00000029;
}

.tri-left .fantan-bet-lot-bet-no,
.tri-right .fantan-bet-lot-bet-no {
  padding: 0 10px;
}

.middle .fantan-bet-lot-bet-no {
  // @extend .tai-xiu-game-bet-no;
  // margin-top: 0px;
  font-family: "Oswald";
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  padding: 0;
  text-shadow: 0px 1px 0px #00000029;
}

.fantan-bet-lot-bet-no.small {
  height: unset;
}
</style>

<style lang="scss">
.tri-top-ph .fantan-bet-lot-cell,
.tri-bottom-ph .fantan-bet-lot-cell {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  vertical-align: middle;
  align-items: center;
}

.fantan-bet-lot-cell.fantan-bet-lot-cell-active .fantan-bet-lot-title {
  color: #fff;
}

.tri-top-ph .fantan-bet-lot-stake-total,
.tri-bottom-ph .fantan-bet-lot-stake-total,
.tri-left-ph .fantan-bet-lot-stake-total,
.tri-right-ph .fantan-bet-lot-stake-total {
  display: none !important;
}

.middle-ph .square-o .fantan-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 1px;
  right: 51.3%;
  // top: 0;
  // right: 50%;
  text-align: center;
  font-weight: bold;
  font-size: 10px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}

.middle-ph .square-e .fantan-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  // top: 0;
  // right: 0;

  top: 1px;
  right: 1px;

  text-align: center;
  font-weight: bold;
  font-size: 10px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}

.middle-ph .fantan-bet-lot-cell {
  height: 65px;
  border-radius: 10px;
}

.middle-ph .fantan-bet-lot-cell {
  padding-top: 15px;
}

.middle-ph .fantan-bet-lot-cell.fantan-bet-lot-cell-active {
  background: #6221f4;
  color: #fff !important;
}

.tri-top .fantan-bet-lot-stake-total {
  border-radius: 5px;
  right: 10%;
  top: 0%;
}

.tri-bottom .fantan-bet-lot-stake-total {
  border-radius: 5px;
  right: 10%;
  top: 17px;
}
</style>
